import { useEffect, useState } from 'react';
import { useThree } from '@react-three/fiber';

/** Works in both the XR editor and the plain mobile Canvas. */
export function useMediaXRSession() {
  const gl = useThree(s => s.gl);
  const [session, setSession] = useState(() => gl.xr.getSession());
  useEffect(() => {
    const start = () => setSession(gl.xr.getSession());
    const end = () => setSession(null);
    gl.xr.addEventListener('sessionstart', start);
    gl.xr.addEventListener('sessionend', end);
    return () => {
      gl.xr.removeEventListener('sessionstart', start);
      gl.xr.removeEventListener('sessionend', end);
    };
  }, [gl]);
  return session;
}
